import { GLOBAL } from 'saddlebag-browser';
import { SingleValueCookie } from 'saddlebag-cookie';
import { getCommonsDateTime } from 'saddlebag-grappler';
import { isLoggedIn, getUtid } from 'saddlebag-user-management';
import { v4 as uuidv4 } from 'uuid';

const isValidGuid = ({ messageGuid }) =>
  messageGuid === undefined ||
  // eslint-disable-next-line prefer-regex-literals
  new RegExp(
    '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$', // NOSONAR No ReDos risk on client
  ).test(messageGuid);

const getPreferencesString = () =>
  new SingleValueCookie('preferences').getValue();

class Message {
  constructor(schema, opts = {}) {
    if (!schema) {
      throw new Error('A schema must be provided');
    }

    this.$window = GLOBAL.getWindow();
    this.message = null;
    this.opts = opts;
  }

  async buildHeader(guid) {
    const loggedIn = await isLoggedIn();

    const clientContext = this.opts.page_name
      ? { client_context: { page_name: this.opts.page_name } }
      : {};
    const jhaToken =
      new SingleValueCookie('jha').getValue() || this.opts.jhaToken || '';

    return {
      header: {
        guid,
        client_timestamp: getCommonsDateTime(new Date(), true),
        traveller_identity: {
          utid: getUtid(),
          authentication_status: loggedIn ? 'AUTHENTICATED' : 'UNAUTHENTICATED',
          preference_string: getPreferencesString(),
        },
        producer_name: this.opts.service_name,
        sequence_number: this.opts.sequence_number,
        experiment_allocation_id:
          new SingleValueCookie('experiment_allocation_id').getValue() || '',
        user_agent: this.$window.navigator
          ? this.$window.navigator.userAgent
          : 'UNKNOWN',
        jekyll_hyde_analytics_token: jhaToken,
        ...clientContext,
      },
    };
  }

  createGuid() {
    return this.opts.messageGuid || uuidv4();
  }

  async buildMessage(message) {
    const guid = this.createGuid();
    const header = await this.buildHeader(guid);

    const newMessage = {
      ...header,
      ...message,
    };

    this.message = newMessage;
    return this.message;
  }

  get() {
    return this.message;
  }
}

export default Message;
export { isValidGuid };
